/**
 * Converts a degree value to radians.
 * @param {Number} degree - The degree to be converted to radians
 * @return {Number} The degree input in radians.
*/

export default function toRadian(degree) {
  return degree * Math.PI / 180
}



// WEBPACK FOOTER //
// ./src/helpers/toRadian.js